import type { GeocodeResult } from '../types/database';

/** Sydney CBD — temporary mock geocode when Google APIs are unavailable. */
const SYDNEY_CENTER = { lat: -33.8688, lng: 151.2093 };

/** ~12 km radius in degrees (rough). */
const LAT_SPAN = 0.11;
const LNG_SPAN = 0.14;

function envFlag(value: string | undefined | null, defaultOn = true): boolean {
  if (value == null || value === '') return defaultOn;
  const normalized = value.trim().toLowerCase();
  return normalized !== '0' && normalized !== 'false' && normalized !== 'off';
}

/** TEMPORARY: default ON. Set VITE_GEOCODE_MOCK_SYDNEY=false to restore Google. */
export function isGeocodeMockSydneyEnabled(): boolean {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return envFlag(import.meta.env.VITE_GEOCODE_MOCK_SYDNEY as string | undefined, true);
  }
  return true;
}

/** Random point around Sydney; keeps the typed address as formatted_address. */
export function mockSydneyGeocode(address: string): GeocodeResult {
  const trimmed = address.trim();
  const lat = SYDNEY_CENTER.lat + (Math.random() * 2 - 1) * LAT_SPAN;
  const lng = SYDNEY_CENTER.lng + (Math.random() * 2 - 1) * LNG_SPAN;
  return {
    lat: Number(lat.toFixed(6)),
    lng: Number(lng.toFixed(6)),
    formatted_address: trimmed,
  };
}
